import React, { useEffect, useState } from 'react';
import ForecastRecipientEdit from './ForecastRecipientEdit';
import ForecastRecipientTable from './ForecastRecipientTable';
import { BOOTSTRAP_BREAKPOINTS, checkBreakpoint } from '@awp/helpers/UIHelper';
import { GetJson } from '@awp/helpers/fetchReact';
import { FORM_MODE, REST_API } from '@awp/constants';
import { debounce } from '@awp/helpers/Utils';
import { AwpContainer } from '../Common/AwpContainer';
import { DEFAULT_PAGE_SIZE } from '@components/table';

const ForecastRecipient = () => {
  const [mode, setMode] = useState('list');
  const [isMedium, setIsMedium] = useState(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.MEDIUM));
  const [isLarge, setIsLarge] = useState(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.LARGE));
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [forecastRecipientId, setForecastRecipientId] = useState(null);

  const [selectedProgram, setSelectedProgram] = useState(null);
  const [selectedArea, setSelectedArea] = useState(null);
  const [search, setSearch] = useState('');
  const [selectedUserType, setSelectedUserType] = useState(null);
  const [defaultPageSize, setDefaultPageSize] = useState(DEFAULT_PAGE_SIZE);

  useEffect(() => {
    setLoading(true);
    const url = REST_API.FORECAST_RECIPIENTS;

    GetJson(url)
      .then((response) => response.json())
      .then((data) => {
        setData(data);
        setFilteredData(data);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const handleResize = debounce(() => {
      setIsMedium(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.MEDIUM));
      setIsLarge(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.LARGE));
    }, 100);

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  const tableProps = {
    isMedium,
    isLarge,
    setData,
    data,
    filteredData,
    setFilteredData,
    loading,
    setMode,
    setForecastRecipientId,
    forecastRecipientId,
    selectedProgram,
    setSelectedProgram,
    selectedArea,
    setSelectedArea,
    selectedUserType,
    setSelectedUserType,
    search,
    setSearch,
    defaultPageSize,
    setDefaultPageSize,
  };

  const editProps = {
    setMode,
    mode,
    setForecastRecipientId,
    forecastRecipientId,
    data,
    setData,
    setLoading,
    loading,
  };

  return (
    <AwpContainer>
      {mode === FORM_MODE.LIST ? <ForecastRecipientTable {...tableProps} /> : <ForecastRecipientEdit {...editProps} />}
    </AwpContainer>
  );
};

export default ForecastRecipient;
